import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Modal,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  ButtonGroup,
} from "@mui/material";

import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimeField } from "@mui/x-date-pickers/DateTimeField";
// import "../Add.css"
import "./DisasterAddForm.css";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Map from "./DsMap";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 1,
};

export default function DisasterAddFormModal(props) {
  const [formInputsValidity, setFormInputsValidity] = useState({
    sort: true,
    name: true,
    address: true,
    date: true,
    lat: true,
    lon: true,
    detailed: true,
  });

  const [sort, setSort] = useState("V"); // 재난종류
  // const [name, setName] = useState("");
  // const [address, setAddress] = useState("");
  const nowDate = new Date().toISOString("YYYY-MM-DDTHH:mm");
  const [date, setDate] = useState(dayjs(nowDate));
  // const [lat, setLat] = useState("");
  // const [lon, setLon] = useState("");
  // const [detailed, setDetailed] = useState("");

  const sortRef = useRef("");
  const titleRef = useRef("");
  const addrRef = useRef("");
  const dateRef = useRef("");
  const latRef = useRef("");
  const lonRef = useRef("");
  const detailedRef = useRef("");

  const [allRdvList, setAllRdvList] = useState([]);
  const [selectedRdvIds, setSelectedRdvIds] = useState([]);
  const [rdvModalOpen, setRdvModalOpen] = useState(false);
  const [showAllRdvs, setShowAllRdvs] = useState(false);

  // 컴포넌트가 열릴 때 초기화 및 자원집결지 목록 로드
  useEffect(() => {
    if (props.open) {
      setSort("V");
      setDate(dayjs(nowDate));
      setSelectedRdvIds([]);
      setShowAllRdvs(false);
      if (titleRef.current) titleRef.current.value = "";
      if (addrRef.current) addrRef.current.value = "";
      if (latRef.current) latRef.current.value = "";
      if (lonRef.current) lonRef.current.value = "";
      if (detailedRef.current) detailedRef.current.value = "";
      setFormInputsValidity({
        sort: true,
        name: true,
        address: true,
        date: true,
        lat: true,
        lon: true,
        detailed: true,
      });
      if (props.apiAddr) {
        fetch(`${props.apiAddr}/get/getrdvlist`)
          .then((res) => res.json())
          .then((raw) => {
            const data = Array.isArray(raw)
              ? raw
              : raw && typeof raw === "object"
                ? Object.values(raw)
                : [];
            const hq =
              (typeof localStorage !== "undefined" &&
                localStorage.hq &&
                localStorage.hq.trim()) ||
              "";
            const filtered = hq
              ? data.filter((item) => (item.hq || "").trim() === hq)
              : data;
            setAllRdvList(filtered);
          })
          .catch(() => setAllRdvList([]));
      } else {
        setAllRdvList([]);
      }
    }
  }, [props.open, props.apiAddr]);

  const onSubmitHandler = (event) => {
    // 재난등록 버튼 클릭시 데이터 전송
    event.preventDefault();
    const enterdSortIsValid = sort.trim() !== "V";
    const enterdNameIsValid = titleRef.current.value.trim() !== "";
    const enterdAddressIsValid = addrRef.current.value.trim() !== "";
    const enterdDateIsValid = date !== "";
    const enterdLatIsValid = latRef.current.value.trim() !== "";
    const enterdLonIsValid = lonRef.current.value.trim() !== "";
    const enterdDetailedIsValid = detailedRef.current.value.trim() !== "";

    setFormInputsValidity({
      sort: enterdSortIsValid,
      name: enterdNameIsValid,
      address: enterdAddressIsValid,
      date: enterdDateIsValid,
      lat: enterdLatIsValid,
      lon: enterdLonIsValid,
      detailed: enterdDetailedIsValid,
    });

    const formIsValid =
      enterdSortIsValid &&
      enterdNameIsValid &&
      enterdAddressIsValid &&
      enterdDateIsValid &&
      enterdLatIsValid &&
      enterdLonIsValid &&
      enterdDetailedIsValid;

    if (!formIsValid) {
      alert("모든 항목을 입력해주세요.");
      return;
    }

    //const datastring = sort+"^"+name+"^"+address+"^"+date.format("YYYY-MM-DD HH:mm:ss")+"^"+lat+"^"+lon+"^"+detailed;

    const disasterData = {
      sort: sort,
      name: titleRef.current.value.trim(),
      address: addrRef.current.value.trim(),
      date: date.format("YYYY-MM-DD HH:mm:ss"),
      lat: latRef.current.value.trim(),
      lon: lonRef.current.value.trim(),
      detailed: detailedRef.current.value.trim(),
      org: localStorage.org,
      inputid: localStorage.loginid, // 사용자 아이디
      inputhq: localStorage.hq, // 소속본부
      inputOrgName: localStorage.org, // 소속관서명
      rdv_ids: selectedRdvIds, // 자원집결지 id 배열
    };

    console.log(disasterData);

    async function sendDataToDb(disasterData) {
      const wstring = `${props.apiAddr}/post/dsinput`;
      try {
        const response = await fetch(wstring, {
          method: "POST",
          body: JSON.stringify(disasterData),
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) throw new Error("데이터 입력 중 오류 발생");
        const responseData = await response.json();
        console.log(responseData.result);
        if (responseData.result === "success") {
          alert("데이터가 입력되었습니다.");
          props.onDataChanged();
          props.onClose(); // 성공 시 모달 닫기
        } else {
          alert("데이터 입력 실패");
        }
      } catch (error) {
        console.error("Error submitting data:", error);
        alert("데이터 입력 중 오류가 발생했습니다.");
      }
    }

    sendDataToDb(disasterData); // 데이터 입력 전송 호출
  };

  const confirm = (event) => {
    if (window.confirm("등록하시겠습니까?")) {
      onSubmitHandler(event);
    }
  };

  const handleChange = (event) => {
    setSort(event.target.value);
  };

  const getlocaddr = (rlat, rlon, raddr) => {
    console.log(rlat, rlon, raddr);

    latRef.current.value = " ";
    lonRef.current.value = " ";
    addrRef.current.value = " ";
    latRef.current.value = rlat + " ";
    lonRef.current.value = rlon;
    addrRef.current.value = raddr;
  };

  const tokenizeAddress = (value) =>
    (value || "")
      .split(/\s+/)
      .map((token) => token.trim())
      .filter(Boolean);

  const getPriorityRdvList = () => {
    const addressTokens = tokenizeAddress(addrRef.current?.value || "");
    if (addressTokens.length === 0) {
      return allRdvList;
    }

    const topLevelRegion = addressTokens[0];
    const localAreaTokens = addressTokens.slice(1);

    const prioritized = allRdvList.filter((rdv) => {
      const sigun = (rdv.sigun || "").trim();
      const rdvAddress = (rdv.raddr || "").trim();

      if (!sigun && !rdvAddress) return false;

      // 시군명 일치 또는 주소 내 지역 키워드 일치 시 우선 노출
      if (sigun && addressTokens.some((token) => token.includes(sigun))) {
        return true;
      }
      if (rdvAddress && localAreaTokens.some((token) => rdvAddress.includes(token))) {
        return true;
      }
      return rdvAddress.includes(topLevelRegion);
    });

    return prioritized.length > 0 ? prioritized : allRdvList;
  };

  const priorityRdvList = getPriorityRdvList();
  const visibleRdvList = showAllRdvs ? allRdvList : priorityRdvList;

  // const inputtitle = () => {
  //   addrRef.current.valueOf = "지도클릭시자동입력";
  //   latRef.current.valueOf = "지도클릭시자동입력";
  //   lonRef.current.valueOf = "지도클릭시자동입력";
  // }

  return (
    <>
      <Modal
        open={props.open ?? false}
        onClose={props.onClose ?? (() => {})}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="h6" color="gray" textAlign="center" mb={1}>
            재난등록
          </Typography>

          <form onSubmit={onSubmitHandler}>
            <Box>
              <Grid item={true} container spacing={0}>
                <Grid
                  item={true}
                  className="g1"
                  xs={3}
                  style={{ borderTop: "1px solid grey" }}
                >
                  재난종류
                </Grid>
                <Grid
                  item={true}
                  className="g2"
                  xs={9}
                  style={{ borderTop: "1px solid grey" }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      재난선택
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="sort"
                      value={sort}
                      ref={sortRef}
                      label="sort"
                      onChange={(e) => setSort(e.target.value)}
                      size="small"
                    >
                      <MenuItem value={"V"}>항목선택</MenuItem>
                      <MenuItem value={"F"}>대형화재</MenuItem>
                      <MenuItem value={"R"}>수색구조</MenuItem>
                      <MenuItem value={"E"}>다수사상자</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item={true} className="g1" xs={3}>
                  재난명
                </Grid>
                <Grid item={true} className="g2" xs={9}>
                  <TextField
                    id="outlined-basic"
                    label="재난명"
                    variant="outlined"
                    size="small"
                    inputRef={titleRef}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item={true} className="g1" xs={3}>
                  주소
                </Grid>
                <Grid item={true} className="g2" xs={9}>
                  <TextField
                    id="address"
                    label="주소(지도클릭시 자동입력)"
                    variant="outlined"
                    size="small"
                    inputRef={addrRef}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item={true} className="g1" xs={3}>
                  발생일시
                </Grid>
                <Grid item={true} className="g2" xs={9}>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="ko"
                  >
                    <DemoContainer
                      components={["DateTimeField", "DateTimeField"]}
                    >
                      <DateTimeField
                        label="발생일시"
                        value={date}
                        onChange={(newValue) => setDate(newValue)}
                        size="small"
                        format="YYYY-MM-DD HH:mm:ss"
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
                <Grid item={true} className="g1" xs={3}>
                  좌표
                </Grid>
                <Grid item={true} className="g2" xs={9}>
                  <TextField
                    id="outlined-basic"
                    label="위도(지도클릭시 자동입력)"
                    variant="outlined"
                    size="small"
                    inputRef={latRef}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    id="outlined-basic"
                    label="경도(지도클릭시 자동입력)"
                    variant="outlined"
                    size="small"
                    inputRef={lonRef}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item={true} className="g1" xs={3}>
                  자원집결지 선택
                </Grid>
                <Grid item={true} className="g2" xs={9}>
                  <Button
                    fullWidth
                    variant="outlined"
                    size="small"
                    onClick={() => setRdvModalOpen(true)}
                    sx={{
                      justifyContent: "flex-start",
                      textTransform: "none",
                      textAlign: "left",
                    }}
                  >
                    {selectedRdvIds.length === 0
                      ? "집결지 선택(클릭)"
                      : selectedRdvIds
                          .map(
                            (id) =>
                              allRdvList.find((r) => r.id === id)?.rname || id,
                          )
                          .filter(Boolean)
                          .join(", ")}
                  </Button>
                  <Modal
                    open={rdvModalOpen}
                    onClose={() => setRdvModalOpen(false)}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: 560,
                        maxHeight: "85vh",
                        bgcolor: "background.paper",
                        borderRadius: 1,
                        boxShadow: 24,
                        p: 2,
                        overflow: "auto",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{ mb: 1.5 }}
                      >
                        이 재난에 적용할 자원집결지를 버튼을 눌러 선택하세요.
                        여러 개 선택 가능합니다.
                      </Typography>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "repeat(5, 1fr)",
                          gap: 0.75,
                          mb: 2,
                        }}
                      >
                        {allRdvList.length === 0 ? (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ gridColumn: "1 / -1", py: 2 }}
                          >
                            등록된 집결지가 없습니다.
                          </Typography>
                        ) : (
                          visibleRdvList.map((rdv) => {
                            const isSelected = selectedRdvIds.includes(rdv.id);
                            return (
                              <Button
                                key={rdv.id}
                                variant={isSelected ? "contained" : "outlined"}
                                size="small"
                                onClick={() =>
                                  setSelectedRdvIds((prev) =>
                                    isSelected
                                      ? prev.filter((id) => id !== rdv.id)
                                      : [...prev, rdv.id],
                                  )
                                }
                                sx={{
                                  textTransform: "none",
                                  fontSize: "0.8rem",
                                  py: 0.75,
                                  minHeight: 36,
                                }}
                              >
                                {rdv.rname || `(id: ${rdv.id})`}
                              </Button>
                            );
                          })
                        )}
                      </Box>
                      {allRdvList.length > priorityRdvList.length && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            mb: 1.5,
                          }}
                        >
                          <Button
                            variant="text"
                            size="small"
                            onClick={() => setShowAllRdvs((prev) => !prev)}
                          >
                            {showAllRdvs
                              ? `접기 (해당지역 ${priorityRdvList.length}개)`
                              : `추가보기 (전체 ${allRdvList.length}개)`}
                          </Button>
                        </Box>
                      )}
                      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                          variant="contained"
                          onClick={() => setRdvModalOpen(false)}
                        >
                          확인
                        </Button>
                      </Box>
                    </Box>
                  </Modal>
                </Grid>
                <Grid
                  item={true}
                  className="g1"
                  xs={3}
                  sx={{ height: "300px" }}
                >
                  지도
                </Grid>
                <Grid
                  id="mapcntr"
                  item={true}
                  className="g2"
                  xs={9}
                  sx={{ height: "300px" }}
                >
                  <Map id="map" clickedvalue={getlocaddr} />
                </Grid>
                <Grid item={true} className="g1" xs={3}>
                  세부내용
                </Grid>
                <Grid item={true} className="g2" xs={9}>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    label="재난 개요, 현재 양상 등 세부내용"
                    size="small"
                    inputRef={detailedRef}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container item={true} xs={12} justifyContent={"center"}>
                <ButtonGroup
                  variant="contained"
                  aria-label="outlined button group"
                  sx={{ mt: 1, gap: 2 }}
                >
                  <Button bgcolor={"green"} onClick={confirm}>
                    등록
                  </Button>
                  <Button bgcolor={"red"} onClick={props.onClose}>
                    취소
                  </Button>
                </ButtonGroup>
              </Grid>
            </Box>
          </form>
        </Box>
      </Modal>
      {/* {setTimeout(() => { inputtitle()}, 100)} */}
    </>
  );
}
